import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
export interface ContractInfo {
    symbol?: string;
    decimals?: number;
    name?:string
}

interface ContractStore {
    contracts: Record<string, ContractInfo>;

    getContract: (chainId: number, contractAddress: string) => ContractInfo | undefined;

    setContractSymbol: (chainId: number, contractAddress: string, symbol: string) => void;

    setContractDecimals: (chainId: number, contractAddress: string, decimals: number) => void;

    setContractName: (chainId: number, contractAddress: string, name: string) => void;

    setContracts: (data: { chainId: number; contractAddress: string; info: ContractInfo }[]) => void;
}

const persistedState = persist<ContractStore>(
    (set, get) => ({
        contracts: {},

        getContract: (chainId, contractAddress) => {
            const key = `${chainId}-${contractAddress.toLowerCase()}`;
            return get().contracts[key];
        },

        setContractName: (chainId, contractAddress, name) => {
            const key = `${chainId}-${contractAddress.toLowerCase()}`;
            set((state) => {
                const updatedContracts = {
                    ...state.contracts,
                    [key]: { ...state.contracts[key], name },
                };
                return { contracts: updatedContracts };
            });
        },

        setContractSymbol: (chainId, contractAddress, symbol) => {
            const key = `${chainId}-${contractAddress.toLowerCase()}`;
            set((state) => {
                const updatedContracts = {
                    ...state.contracts,
                    [key]: { ...state.contracts[key], symbol },
                };
                return { contracts: updatedContracts };
            });
        },

        setContractDecimals: (chainId, contractAddress, decimals) => {
            const key = `${chainId}-${contractAddress.toLowerCase()}`;
            set((state) => {
                const updatedContracts = {
                    ...state.contracts,
                    [key]: { ...state.contracts[key], decimals },
                };
                return { contracts: updatedContracts };
            });
        },

        setContracts: (data) => {
            set((state) => {
                const newContracts = { ...state.contracts };
                data.forEach(({ chainId, contractAddress, info }) => {
                    const key = `${chainId}-${contractAddress.toLowerCase()}`;
                    newContracts[key] = { ...newContracts[key], ...info };
                });
                return { contracts: newContracts };
            });
        },
    }),
    { name: 'match-contract-local' }
);

const useContractStore = create(devtools(persistedState));

export default useContractStore;
